<template>
<div class="chapter">
<div class="inner_page">
<p class="title">Rescuing Dr. McAllister</p>
<p class="author">Sarah Morgan</p>
<p class="image"><img alt="Image" height="59" src="publogo.jpg" width="270"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781460377659_booktitlepage.vue?7580fc08